import * as Yup from "yup";

export default Yup.object().shape({
    name: Yup.string().required("Please enter a Media Type name"),
    companyId: Yup.number().min(1, "Please select a Company").required()
});